
export enum DynamicPriceRestrictionTypeCd {
	EXCLUDE = 'Exclude',
	INCLUDE = 'Include'}

